import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { MastheadComponent } from './masthead/masthead.component';
import { MasterBrandComponent } from './master-brand/master-brand.component';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule  } from '@angular/forms';
import NavMenuService from '../navigation-menu/nav-menu-service';
import { AppMonitoringService } from '../services/logging.service';



@NgModule({
	declarations: [
		HeaderComponent, 
		MastheadComponent, 		
		MasterBrandComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		MatAutocompleteModule
	],
	exports : [
		HeaderComponent, 
		MasterBrandComponent, 
		MastheadComponent
	],
	providers : [NavMenuService,AppMonitoringService]

})
export class HeaderModule { }
